import Nosotros from './Nosotros'
export default Nosotros